<template>
  <div class="navbar">
    <div class="logo">
      <div class="logodiv">
        <img src="@/assets/img/login/logo.svg">
      </div>
      <div class="logotitle">
        <!-- <span>{{ name }}</span> -->
      </div>
    </div>
    <div class="nav-title">
      系統設定
    </div>
    <div
      class="back-home"
      @click="enterHome">返回首頁</div>
    <div
      class="go-out"
      @click="enterLogin">退出系統</div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import { mapGetters } from 'vuex'

export default {
  components: {},
  props: {
    navIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters([
      'logoadmin',
      'name'
    ])
  },

  mounted() {},
  methods: {
    enterHome() {
      this.$router.replace({
        path: '/'
      })
    },
    enterLogin() {
      this.$confirm('退出登錄？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var loading = Loading.service({
            target: document.getElementById('#app')
          })
          this.$store
            .dispatch('LogOut')
            .then(() => {
              loading.close()
              this.$router.push('/login')
            })
            .catch(() => {
              loading.close()
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 60px;
  min-height: 60px;
  display: flex;
  align-items: center;
  padding: 0 90px 0 30px;
  background-color: #2486e4;
  .logo {
    width: 180px;
    height: 50px;
    display: block;
    flex-shrink: 0;
    margin-right: 60px;
    display: flex;

  }
  .logo .logodiv{
    // width: 100%;
    height: 100%;
  }
  .logo .logotitle{
    width: 40%;
    margin-left:10px;
    align-self: center;
    font-size: 18px;
    color: #FFF;
  }
  .logo img {
    // max-width: 100%;
    height: 100%;
    // margin-top: -20px;
    // margin-left: -28px;
  }
  .nav-title {
    flex: 1;
    font-size: 16px;
    color: #FFFFFF;
  }
}

.back-home {
  width: 94px;
  height: 36px;
  line-height: 36px;
  background-color: #2486e4;
  border-radius: 3px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer;
}

.go-out {
  width: 94px;
  height: 36px;
  line-height: 36px;
  background-color: #c2c2c2;
  border-radius: 3px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
</style>

